import swal from "sweetalert2"
<template>
<div>
  <div class="row">
    <div class="col-md-12">
      <div class="date">
        <label class="demonstration">Intevalo de tempo para o relatório de lâmpadas por usuário:</label>
        <br>
        <el-date-picker
          v-model="rangeDate"
          type="daterange"
          format="dd/MM/yyyy"
          start-placeholder="Data início"
          end-placeholder="Data término"
        >
        </el-date-picker>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-xs-12">
      <input
        type="checkbox"
        v-model="allUsers"
      > Inserir todos os usuários, inclusive os que nunca realizaram uma troca se quer, no relatório?
    </div>
  </div>
  <div class="row">
    <div class="col-xs-12">
      <button
        v-loading="reporting"
        class="btn btn-wd btn-fill btn-tertiary"
        @click="loadingReport"
      >
        Relatório de Lâmpadas por usuários
      </button>
    </div>
  </div>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import swal from 'sweetalert2'
import blobUtils from 'blob-util'
import downloadJs from 'downloadjs'

export default {
  name: 'LampsUsersReport',
  props: {
    csvSeparator: {
      required: true,
      default: ';'
    }
  },
  data () {
    return {
      allUsers: false,
      csv: '',
      rangeDate: [],
      reporting: false,
      lampsData: {},
      headers: {
        'name': 'Nome',
        'dates': []
      }
    }
  },
  computed: {
    ...mapGetters('users', ['users']),
    ...mapGetters('events', ['events']),
    ...mapGetters('lamps', {lamps: 'lampsAll'}),
    queryDateRange () {
      return this.rangeDate.length === 2 ? [this.rangeDate[0], new Date(this.rangeDate[1].setDate(this.rangeDate[1].getDate() + 1))] : []
    }
  },
  methods: {
    ...mapActions('users', {fetchUsers: 'fetchAll'}),
    ...mapActions('lamps', {fetchLamps: 'fetchAll'}),
    loadingReport () {
      swal({
        title: 'Informações',
        text: 'Estamos gerando o relatório. Por favor aguarde e não recarregue ou feche a página.',
        type: 'info',
        showConfirmButton: false,
        allowOutsideClick: false,
        onOpen: async () => {
          swal.showLoading()
          await this.runReport()
          swal.hideLoading()
          swal.close()
        }
      })
        .catch(err => {
          console.log(err)
        })
    },
    async runReport () {
      await this.getLamps()
      await this.buildReport()
    },
    async getLamps () {
      const query = {}
      if (this.queryDateRange.length === 2) {
        query['createdAt'] = {
          '$gte': this.queryDateRange[0],
          '$lt': this.queryDateRange[1]
        }
      }
      return this.fetchLamps({where: query, limit: 9999999, select: ['userId', 'items', 'createdAt']})
        .then(() => {
          for (let lamp of this.lamps) {
            if (!lamp.hasOwnProperty('userId') || !lamp.hasOwnProperty('items')) {
              continue
            }
            if (!this.lampsData.hasOwnProperty(lamp.userId)) {
              this.lampsData[lamp.userId] = {}
            }
            const date = `${new Date(lamp.createdAt).getFullYear()}-${new Date(lamp.createdAt).getMonth() + 1}`
            if (!this.headers.dates.find(item => item === date)) {
              this.headers.dates.push(date)
            }
            if (!this.lampsData[lamp.userId].hasOwnProperty(date)) {
              this.lampsData[lamp.userId][date] = 0
            }
            this.lampsData[lamp.userId][date] += lamp.items.length
          }
        })
    },
    async buildReport () {
      this.insertHeaders()
      this.insertBody()
      this.download(this.csv)
    },
    insertBody () {
      for (let user of this.users) {
        if (user.name === 'Codeseven') {
          continue
        }

        if (!this.lampsData.hasOwnProperty(user._id)) {
          if (this.allUsers) {
            this.insertUserWithoutLamps(user)
          }
          continue
        }

        this.csv += `"${user.name}"`
        this.csv += this.csvSeparator

        for (let date of this.headers.dates) {
          if (!this.lampsData[user._id].hasOwnProperty(date)) {
            this.csv += '0'
            this.csv += this.csvSeparator
            continue
          }

          this.csv += `"${this.lampsData[user._id][date]}"`
          this.csv += this.csvSeparator
        }
        this.csv += '\n'
      }
    },
    insertUserWithoutLamps (user) {
      this.csv += `"${user.name}"`
      this.csv += this.csvSeparator

      for (let date of this.headers.dates) {
        date = date[0] // passando do lint
        this.csv += '0'
        this.csv += this.csvSeparator
      }
      this.csv += '\n'
    },
    insertHeaders () {
      this.headers.dates = this.headers.dates.sort((a, b) => {
        let dateA = a.split('-')
        let dateB = b.split('-')
        dateA = [parseInt(dateA[1]) < 10 ? `0${dateA[1]}` : dateA[1], dateA[0]].join()
        dateB = [parseInt(dateB[1]) < 10 ? `0${dateB[1]}` : dateB[1], dateA[0]].join()
        return dateA.localeCompare(dateB)
      })
      this.csv += `"${this.headers.name}"`
      this.csv += this.csvSeparator
      for (let date of this.headers.dates) {
        this.csv += `"${date}"`
        this.csv += this.csvSeparator
      }
      this.csv += '\n'
    },
    download (report) {
      let blob = blobUtils.createBlob([report], {type: 'text/plain'})
      let now = this.$moment(new Date()).format('DD-MM-YYYY_HH-mm-ss')
      let filename = `Relatório de lampadas por usuário_${now}`
      downloadJs(blob, `${filename}.csv`, 'text/csv')
    }
  },
  mounted () {
    this.fetchUsers({select: ['_id', 'name'], limit: 9999})
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Reports/LampsUsersReport.vue